import { disableScroll, enableScroll } from "../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

	const searchButton = document.querySelector('.wcl-header .wcl-search-button');
	const searchModal = document.querySelector('.wcl-header .wcl-search-modal');
	const searchModalCloseButton = document.querySelector('.wcl-header .wcl-search-modal-close');

	if ( searchButton && searchModal ) {
		searchButton.addEventListener('click', e => {
			e.preventDefault();

			if ( !searchModal.classList.contains('active') ) {
				disableScroll();

				searchModal.classList.add('active');
			}
		});
	}

	if ( searchModalCloseButton && searchModal ) {
		searchModalCloseButton.addEventListener('click', e => {
			e.preventDefault();

			if ( searchModal.classList.contains('active') ) {
				enableScroll();

				searchModal.classList.remove('active');
			}
		});
	}

	if ( searchModal ) {
		searchModal.addEventListener('click', e => {
			if ( e.target === searchModal ) {
				enableScroll();

				searchModal.classList.remove('active');
			}
		});
	}
});
